<template>
  <div class="container mx-auto px-4 lg:px-0">
        <slot/>
     </div>
</template>

<script>
export default {
    name: "Container"
}
</script>
